import { defineStore } from "pinia";

export const useHomeStore = defineStore("homeStore", {
  state: () => {
    return {
      current: <any>null,
    };
  },
  getters: {
    home: (state: any) => {
      return state.current;
    },
    title: (state: any) => {
      return state.current?.title;
    },
    titlePage: (state: any) => {
      return state.current?.data[0]?.titlePage;
    },
    text: (state: any) => {
      return state.current?.data[0]?.text;
    },
    grid: (state: any) => {
      return state.current?.data[0]?.grid;
    },
    blocks: (state: any) => {
      return state.current?.data[0]?.blocks;
    },
    seoTitle: (state: any) => {
      return state.current?.seo?.title;
    },
    seoDescription: (state: any) => {
      return state.current?.seo?.description;
    },
    seoImage: (state: any) => {
      return state.current?.seo?.image;
    },
  },
  actions: {
    setCurrent(payload: any) {
      this.current = payload;
    },
  },
});
